export default "__VITE_ASSET__BAE4EOFk__"